import React, { FC } from 'react';
import BEMHelper from '@ynap/bem-helper';
import { Field as FormField, FieldRenderProps } from '@ynap/form';
import { RadioButton } from '@ynap/radio-button';
import { Messages } from '../AddressForm/@types';

const bem = new BEMHelper('AddressSelectionForm');

interface AddressRadioButtonProps {
    address: string;
    onChange: Function;
    messages?: Messages;
    split?: boolean;
    trackAddNewAddress?: Function;
    reduxForm?: any;
}

const AddAddressRadioButton: FC<AddressRadioButtonProps> = ({ address, onChange: onChangeParent, messages, split = false, trackAddNewAddress }) => {
    return (
        <FormField name="addressId" key={address} value="">
            {({ value, onChange, ...rest }: FieldRenderProps) => {
                const checked = address == value;
                return (
                    <RadioButton
                        {...rest}
                        id={address}
                        value={address}
                        checked={checked}
                        className={bem('addAddress', split ? 'split' : null, 'radio')}
                        label={messages?.addressSelectionForm?.add?.()}
                        onChange={(ev: any) => {
                            onChangeParent();
                            onChange(ev.target.value);
                        }}
                        onClick={() => {
                            onChangeParent();
                            onChange(address);
                            trackAddNewAddress?.();
                        }}
                    />
                );
            }}
        </FormField>
    );
};

export default AddAddressRadioButton;
